<template>
    <header id="inner-header" class="header">
        <div class="container">
            <div class="row">
                <div class="col-md-3 col-sm-12">
                    <div class="logo">
                        <a href="/">
                            <img src="/images/szflogo.png" class="logo-height">
                        </a>
                    </div>
                </div><!-- logo col end -->

                <div class="col-md-9 col-sm-12 header-right">
                    <div class="abd float-right" v-if="(topBanner && topBanner.id) || (gtopBanner && gtopBanner.id)">
                        <div class="col-12 pt-2 pr-0">
                            <ad :data="topBanner" class="mt-3 mt-lg-0" v-if="(topBanner && topBanner.id)"></ad>
                            <google-ad :data="gtopBanner" class="mt-3 mt-lg-0" label="vertical" v-if="(gtopBanner && gtopBanner.id)"></google-ad>
                        </div>
                    </div>

                </div><!-- header right end -->
            </div><!-- Row end -->
        </div><!-- Logo and banner area end -->
    </header>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Ad from '../../components/addons/Ad'
    import GoogleAd from '../../components/addons/GoogleAd'
    import { isMobile } from "../../helpers/helpers";

    export default {
        name: 'InnerHeader',
        data() {
            return {
                banners: [],
                gbanners: [],
                topBanner: {},
                gtopBanner: {},
            }
        },
        components: {
            Ad,
            GoogleAd,
        },
        computed: {
            ...mapGetters([

            ]),
        },
        methods: {
            ...mapActions([

            ]),
            getBanners() {
                let vm = this;
                this.$store.dispatch('getBanners', [
                    'top_90', 'top_90_list', 'top_90_list'
                ]).then((response) => {
                    vm.banners = response ? response : [];

                    if(vm.$router.name === 'home') {
                        vm.topBanner = vm.banners.find(b => b.side === 'top_90');
                    } else if(this.$router.path === 'postList') {
                        vm.topBanner = vm.banners.find(b => b.side === 'top_90_list');
                    } else if(this.$router.path === 'post') {
                        vm.topBanner = vm.banners.find(b => b.side === 'top_90_post');
                    }

                });

                this.$store.dispatch('getGBanners', [
                    'gtop_90', 'gtop_90_list', 'gtop_90_post'
                ]).then((response) => {
                    vm.gbanners = response ? response : [];
                    if(vm.$route.name === 'home') {
                        vm.gtopBanner = vm.gbanners.find(b => b.position === 'gtop_90');
                    } else if(vm.$route.name === 'postList') {
                        vm.gtopBanner = vm.gbanners.find(b => b.position === 'gtop_90_list');
                    } else if(this.$route.name === 'post') {
                        vm.gtopBanner = vm.gbanners.find(b => b.position === 'gtop_90_post');
                    }
                    //console.log('home vm.gtopBanner', vm.gtopBanner, 'gbanners: ', vm.gbanners);
                    //console.log('getGBanners.response: ', response, 'route: ', this.$route.name);
                });
            }
        },
        mounted() {
            this.getBanners();
        },
        watch: {

        }
    }
</script>

<style lang="scss">
    .header {
        padding: 25px 0;

        .logo {

            a {
                img {
                    /* width: 100%; */
                }
            }
        }

        .header-right {
            float: right;
        }
    }

    .w-100 {
        width: 100%;
    }

    .h-100 {
        height: 100%;
    }

    .logo-height {
      height: 100px;
    }
</style>
